import ClusterRepo from './catalog.cattle.io.clusterrepo';

export default class CatalogRepo extends ClusterRepo {
}
